<script setup lang="ts">
import { AppIconButton, AppLazyLoadComponent } from '@libs/ui';

interface HotelStayImageProps {
  imageUrl: string;
  shouldShowOpenGalleryButton: boolean;
}

const props = defineProps<HotelStayImageProps>();

interface HotelStayImageEmits {
  (eventName: 'open-gallery'): void;
}

const emit = defineEmits<HotelStayImageEmits>();
</script>

<template>
  <div class="hotel-stay-image">
    <AppLazyLoadComponent>
      <img class="image" :src="props.imageUrl" :alt="$t('a11y.room_image')" />
    </AppLazyLoadComponent>

    <AppIconButton
      v-if="props.shouldShowOpenGalleryButton"
      state="enabled"
      size="medium"
      :icon="{ name: 'zoom' }"
      type="secondary"
      class="open-gallery-button"
      :ariaLabel="$t('a11y.open_image_gallery')"
      @click="emit('open-gallery')"
    />
  </div>
</template>

<style scoped lang="scss">
.hotel-stay-image {
  max-width: 250px;
  overflow: hidden;
  position: relative;

  @include for-less-or-equal-than-599-px {
    max-width: 100%;
  }

  .image {
    width: 100%;
    aspect-ratio: 4/3;
    height: auto;
    border-radius: var(--border-radius-8);

    @include for-less-or-equal-than-599-px {
      aspect-ratio: 16/9;
    }
  }

  .open-gallery-button {
    position: absolute;
    top: var(--spacing-8);
    right: var(--spacing-8);
  }
}
</style>
